// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JGqU","fullView":"styles_fullView__3G7JR"};